export default "__VITE_ASSET__454ebb50__"